module.exports = __webpack_public_path__ + "img/icon-arrow-down.a63640df.svg";